import { jsx as _jsx } from "react/jsx-runtime";
import { useApplication } from '../../Contexts/ApplicationContext';
import { PaymentFrame } from './PaymentFrame';
import { ErrorPage } from '../ErrorPage/ErrorPage';
export var ThreeDSPaymentPage = function () {
    var currentStep = useApplication().stepController.currentStep;
    if ('threeDsUrl' in currentStep && currentStep.threeDsUrl) {
        return _jsx(PaymentFrame, { url: currentStep.threeDsUrl });
    }
    return _jsx(ErrorPage, {});
};
